module.exports = __webpack_public_path__ + "img/0b373fa0791b6d05738a4f89f96d2291.svg";